export default __webpack_public_path__ + "static/media/deportes.bbea527f.svg";